module.exports = __webpack_public_path__ + "45a6d3c0407172646278e5faa4a75ac8.png";